<template>
	<div
		class="isolate relative p-4 shadow-gray-md overflow-hidden bg-[radial-gradient(circle_at_120%_60%,var(--color-brand-mujglobus-green-light)_65%,var(--color-neutral-300)_65%)] rounded-2.5xl"
	>
		<div class="relative">
			<div class="mr-28 xs:mr-32 sm:mr-40">
				<h4 class="typo-h4 text-heading-primary mb-2">
					Nižší cena pro členy Můj Globus
				</h4>
				<p class="typo-body-s text-body-primary block">
					Staňte se členem našeho věrnostního programu Můj Globus a získejte ještě výhodnější cenu pro vybrané produkty.
				</p>
			</div>
			<div class="flex gap-2 mt-4">
				<CrmRedirectButton class="btn btn-primary btn-lg shadow-sm max-sm:btn-sm w-fit" :user-state="UserState.PRODUCT_DETAIL_MY_GLOBUS_BANNER">
					Registrovat se
				</CrmRedirectButton>
				<AbsoluteInternalLink
					:to="{name: 'vernostni-program'}"
					class="btn btn-secondary btn-lg shadow-sm max-sm:btn-sm w-fit"
				>
					<NuxtIcon name="custom/arrow-right" filled class="text-2xl text-icon-inverse" />
					Více o&nbsp;programu
				</AbsoluteInternalLink>
			</div>
			<NuxtImg
				src="/images/card/my-globus.png"
				srcse="/images/card/my-globus@2x.png"
				alt="Můj Globus karta"
				width="140"
				class="rotate-[15deg] absolute -z-1 max-md:left-[75%] md:-right-6 top-1/2 -translate-y-1/2"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {UserState} from '~/stores/crmStateStore';
</script>
